import { handleActions } from "redux-actions";

const initState = {
  isFetchingProductSuites: false,
  isCreatingProductSuite: false,
  isCreatedProductSuite: false,
  isUpdatingProductSuite: false,
  isUpdatedProductSuite: false,
  isDeletingProductSuite: false,
  isDeletedProductSuite: false,
  productSuites: null,
};

const reducer = handleActions(
  {
    REQUESTED_PRODUCT_SUITES: (state) => ({
      ...state,
      isFetchingProductSuites: true,
      isCreatedProductSuite: false,
      isUpdatedProductSuite: false,
      isDeletedProductSuite: false,
    }),
    RECEIVED_PRODUCT_SUITES: (state, action) => {
      const newState = {
        ...state,
        isFetchingProductSuites: false,
        isCreatedProductSuite: false,
        isUpdatedProductSuite: false,
        isDeletedProductSuite: false,
        productSuites: action.payload.productSuites,
      };
      return newState;
    },
    REQUESTED_CREATE_PRODUCT_SUITE: (state) => {
      const newState = {
        ...state,
        isCreatingProductSuite: true,
        isCreatedProductSuite: false,
      };
      return newState;
    },
    RECEIVED_CREATE_PRODUCT_SUITE: (state, action) => {
      const newState = {
        ...state,
        isCreatingProductSuite: false,
        isCreatedProductSuite: true,
      };
      return newState;
    },
    REQUESTED_UPDATE_PRODUCT_SUITE: (state) => {
      const newState = {
        ...state,
        isUpdatingProductSuite: true,
        isUpdatedProductSuite: false,
      };
      return newState;
    },
    RECEIVED_UPDATE_PRODUCT_SUITE: (state, action) => {
      const newState = {
        ...state,
        isUpdatingProductSuite: false,
        isUpdatedProductSuite: true,
      };
      return newState;
    },
    REQUESTED_DELETE_PRODUCT_SUITE: (state) => {
      const newState = {
        ...state,
        isDeletingProductSuite: true,
        isDeletedProductSuite: false,
      };
      return newState;
    },
    RECEIVED_DELETE_PRODUCT_SUITE: (state, action) => {
      const newState = {
        ...state,
        isDeletingProductSuite: false,
        isDeletedProductSuite: true,
      };
      return newState;
    },
  },
  initState
);

export default reducer;
